// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2Ootb","gfeWrapper":"CalendarEvent_gfeWrapper__3AJTV"};